<template>
  <v-tooltip :text="label" location="right" :disabled="expanded">
    <template #activator="{ props: tooltipProps }">
      <component
        :is="route ? 'router-link' : 'button'"
        v-bind="tooltipProps"
        :to="route ? { name: route } : undefined"
        class="sidebar-nav-item"
        :class="{
          'sidebar-nav-item--active': isActive,
          'sidebar-nav-item--expanded': expanded,
        }"
        @click="$emit('click')">
        <v-icon :icon="icon" size="20" class="sidebar-nav-item__icon" />
        <span v-show="expanded" class="sidebar-nav-item__label">{{ label }}</span>
      </component>
    </template>
  </v-tooltip>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";

const props = defineProps({
  icon: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  route: {
    type: String,
    default: "",
  },
  expanded: {
    type: Boolean,
    default: false,
  },
});

defineEmits(["click"]);

const currentRoute = useRoute();

const isActive = computed(() => {
  if (!props.route) return false;
  return currentRoute.name === props.route;
});
</script>

<style lang="scss" scoped>
@import "@/styles/_variables.scss";

.sidebar-nav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 10px 0;
  border: none;
  background: transparent;
  color: $lh_sidebar_text;
  text-decoration: none;
  cursor: pointer;
  position: relative;
  border-radius: 8px;
  transition: color $lh_transition_fast, background-color $lh_transition_fast;
  font-family: $lh_font_family_dm_sans;
  font-size: 14px;
  font-weight: 500;
  justify-content: center;

  &:hover {
    color: $lh_sidebar_text_active;
    background: $lh_sidebar_bg_hover;
  }
}

.sidebar-nav-item--expanded {
  padding: 10px 16px;
  justify-content: flex-start;
}

.sidebar-nav-item--active {
  color: $lh_sidebar_text_active;
  background: $lh_sidebar_bg_hover;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 6px;
    bottom: 6px;
    width: 3px;
    border-radius: 0 3px 3px 0;
    background: $lh_sidebar_accent;
  }
}

.sidebar-nav-item__label {
  opacity: 0;
  transition: opacity $lh_transition_fast;
  white-space: nowrap;

  .sidebar-nav-item--expanded & {
    opacity: 1;
  }
}
</style>
